import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::assign
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:46
* @route '/motels/{motel}/admins'
*/
export const assign = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

assign.definition = {
    methods: ["post"],
    url: '/motels/{motel}/admins',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::assign
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:46
* @route '/motels/{motel}/admins'
*/
assign.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return assign.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::assign
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:46
* @route '/motels/{motel}/admins'
*/
assign.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::assign
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:46
* @route '/motels/{motel}/admins'
*/
const assignForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::assign
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:46
* @route '/motels/{motel}/admins'
*/
assignForm.post = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assign.url(args, options),
    method: 'post',
})

assign.form = assignForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::revoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:90
* @route '/motels/{motel}/admins/{user}'
*/
export const revoke = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: revoke.url(args, options),
    method: 'delete',
})

revoke.definition = {
    methods: ["delete"],
    url: '/motels/{motel}/admins/{user}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::revoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:90
* @route '/motels/{motel}/admins/{user}'
*/
revoke.url = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            motel: args[0],
            user: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
        user: args.user,
    }

    return revoke.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::revoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:90
* @route '/motels/{motel}/admins/{user}'
*/
revoke.delete = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: revoke.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::revoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:90
* @route '/motels/{motel}/admins/{user}'
*/
const revokeForm = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revoke.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::revoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:90
* @route '/motels/{motel}/admins/{user}'
*/
revokeForm.delete = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: revoke.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

revoke.form = revokeForm

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
export const checkRevoke = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkRevoke.url(args, options),
    method: 'get',
})

checkRevoke.definition = {
    methods: ["get","head"],
    url: '/motels/{motel}/admins/{user}/check-revoke',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
checkRevoke.url = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            motel: args[0],
            user: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
        user: args.user,
    }

    return checkRevoke.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace('{user}', parsedArgs.user.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
checkRevoke.get = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkRevoke.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
checkRevoke.head = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: checkRevoke.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
const checkRevokeForm = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkRevoke.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
checkRevokeForm.get = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkRevoke.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAdminAccessController::checkRevoke
* @see app/Http/Controllers/Admin/Motels/MotelAdminAccessController.php:122
* @route '/motels/{motel}/admins/{user}/check-revoke'
*/
checkRevokeForm.head = (args: { motel: string | number, user: string | number } | [motel: string | number, user: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: checkRevoke.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

checkRevoke.form = checkRevokeForm

const admins = {
    assign: Object.assign(assign, assign),
    revoke: Object.assign(revoke, revoke),
    checkRevoke: Object.assign(checkRevoke, checkRevoke),
}

export default admins